import {Injectable} from '@angular/core';
import {Device, DeviceId, DeviceInfo} from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private infoPromise: Promise<DeviceInfo> | null = null;
  private idPromise: Promise<DeviceId> | null = null;

  async getInfo(): Promise<DeviceInfo> {
    if (this.infoPromise === null) {
      this.infoPromise = Device.getInfo();
    }
    return this.infoPromise;
  }

  async getId(): Promise<DeviceId> {
    if (this.idPromise === null) {
      this.idPromise = Device.getId();
    }
    return this.idPromise;
  }

  async getUuid(): Promise<string> {
    const id = await this.getId();
    return id.identifier;
  }

  async getOsVersion(): Promise<string> {
    const info = await this.getInfo();
    return info.osVersion || '';
  }
}
